import {
  update
} from '../../../utils/vuex'

export default {
  update
}
